/**
 * @generated SignedSource<<909b5cbe0b6f716a4cff2fad99b5aa91>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopAppliedFilters_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useMeasurementUnit_user">;
  readonly " $fragmentType": "SbRespRefineTopAppliedFilters_user";
};
export type SbRespRefineTopAppliedFilters_user$key = {
  readonly " $data"?: SbRespRefineTopAppliedFilters_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineTopAppliedFilters_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineTopAppliedFilters_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMeasurementUnit_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "621345bc73e2beb83b46f384c1d397a9";

export default node;
